module.exports = __webpack_public_path__ + "img/box.fe77090e.svg";